import $ from '../vendor/jquery';

$('.mobile-menu').each(function () {
  var menu = $(this);
  menu.find('.selector').on('click', function () {
    menu.find('ol').slideToggle();
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/header.js